import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ServiceDeliveryInfoConstants } from '../features/ach-enrollment/constants/service-delivery-info.constants';

@Component({
    selector: 'error-page.component',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class ErrorPageComponent {
    public nonPdgPhoneNumber = ServiceDeliveryInfoConstants.NON_PDG_PHONE_NUMBER;
}
